import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../layout/index';
import Login from '../views/Login/index';
import AccountConfig from '../views/AccountConfig/index';
import Password from '../views/AccountConfig/pages/password';
import Regulation from '../views/Regulation/index';
import formRule from '../views/Formconfiguration/index';


import Messages from '../views/Messages/index';

import Client from './ClientManage';
import Cooperation from './CooperationManage';
import Serve from './ServeManage';
import Resource from './ResourceManage';
import Product from './ProductManage';
import Task from './TaskManage';
import User from './UserManage';
import AuthAndArea from './AuthAndArea';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: (to)=>{
      console.log('to', to);
      let path=JSON.parse(localStorage.getItem('menuData'));
      console.log('path', path);
      if(path){
        return path[0].children[0].path;
      }

    },
    children: [
      {
        path: '/accountConfig',
        name: '账号设置',
        component: AccountConfig,
        meta: [{ name: '账号设置' }],
      },
      {
        path: '/password',
        name: '密码设置',
        component: Password,
        meta: [{ name: '密码设置' }],
      },
      {
        path: '/messages',
        name: '消息',
        component: Messages,
        meta: [{ name: '消息' }],
      },
      ...Client,
      ...Cooperation,
      ...Serve,
      ...Resource,
      ...Product,
      ...AuthAndArea,
      ...Task,
      ...User,
	  {
	    path: '/regulation',
	    name: '规则配置',
	    component: Regulation,
	    meta: [{ name: '规则配置' }],
	  },
	  {
	    path: '/formRule',
	    name: '表单配置',
	    component: formRule,
	    meta: [{ name: '表单配置' }],
	  },
    ],
  },
  {
    path: '/login',
    component: Login,
  },
];

const router = new VueRouter({
  routes,
});
// 判断登录
router.beforeEach((from, to, next) => {
  if (from.path !== '/login' && !window.localStorage.getItem('token')) {
    router.replace('/login');
  }
   // localStorage.setItem('fullPath', from.fullPath);
  next();
});

export default router;
